module.exports = __webpack_public_path__ + "img/Online Medical Report.97e30408.svg";